import {Component} from 'react';

class Cam extends Component {
    constructor(props) {
        super(props);

        this.state = {
            cams: [],
            act_uid: '',
            facingMode: this.props.facingMode,
            device_front: null,
            device_back: null,
            log: null,
            camera_output: this.props.selector,
        };

        this.i = 0;
        this.camera_output = null;
        this.cam_found = false;
        this.iphone = false;
        this.my_devices = [];

        this.constraints = {};
        this.stream = null;
        this.first_run = true;
    }

    componentDidMount() {
        console.log(this.props.camera_output,'!!')
        if (this.props.camera_output) {
            this.camera_output = document.querySelector(this.props.camera_output);
            // this.camera_output.addEventListener('click', this.change_device)
            this.camera_output.setAttribute('autoplay', true);
            this.camera_output.setAttribute('playsinline', true);
            this.camera_output.setAttribute('muted', true)
        }
        navigator.mediaDevices &&
        navigator.mediaDevices.enumerateDevices()
            .then(this.gotDevices).then(this.activate_stream);
    }

    gotDevices = (deviceInfos) => {
        // NOTE Should better be outsourced (future checks...)
        this.my_devices = deviceInfos.filter(el => el.kind === 'videoinput');
        if (this.my_devices.length > 0) {
            this.iphone = this.my_devices[0].label === '';
        }

        if (!this.iphone) {
            console.log('found Android');
            this.setState({
                cams: this.my_devices.map(
                    el => {
                        if (el.label.indexOf('front') >= 0) {
                            this.setState({device_front: el.deviceId});
                            this.cam_found = true
                        } else if (el.label.indexOf('back') >= 0) {
                            this.setState({device_back: el.deviceId});
                            this.cam_found = true
                        }

                        return el
                    }
                )
            });
            if (this.my_devices.length > 0 && !this.cam_found) {
                this.setState(
                    {device_front: this.my_devices[0].deviceId, device_back: this.my_devices[0].deviceId}
                )
            }
        } else {
            console.log('found Iphone');
            this.setState({device_front: 'front', device_back: 'enviroment'})
        }
    };

    activate_stream = () => {
        setTimeout(this.getStream, 200)
    };

    getStream = () => {
        if (this.stream) {
            this.stream.getTracks().forEach((track) => {
                track.stop();
            });
        }
        this.constraints = this.iphone ?
            {
                video: {
                    facingMode: this.props.facingMode === 'front' ? this.state.device_front : this.state.device_back,
                    width: {ideal: 1920},
                    height: {ideal: 1080},
                }
            }
            :
            {
                video: {
                    deviceId: {exact: this.props.facingMode === 'front' ? this.state.device_front : this.state.device_back},
                    width: {ideal: 1920},
                    height: {ideal: 1080},
                }
            };
        navigator.mediaDevices.getUserMedia(this.constraints).then(this.gotStream)
    };

    gotStream = (stream) => {
        this.stream = stream;
        if (this.first_run) {
            this.first_run = false;
            navigator.mediaDevices.enumerateDevices()
                .then(this.gotDevices).then(this.activate_stream);
        } else {
            this.camera_output.srcObject = this.stream;
        }
    };

    change_device = () => {
        this.i += 1;
        const sel = this.i % 2 === 0 ? 'front' : 'back';
        this.setState({facingMode: sel});
        this.getStream()
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.active && !prevProps.active) {
            console.log('active again')

            this.camera_output.srcObject = this.stream;
        }
        else if (!this.props.active && prevProps.active) {
            console.log('set inactive')
            this.camera_output.srcObject = null;
        }
    }

    render() {
        return null
    }
}

export default Cam;